import {
  usePopoverStoreOptions,
  usePopoverStoreProps
} from "./SHGWT5HV.js";
import {
  useStore
} from "./AV5WE37O.js";
import {
  __spreadValues
} from "./4BKCJXBM.js";

// src/hovercard/hovercard-store.ts
import * as Core from "@ariakit/core/hovercard/hovercard-store";
function useHovercardStoreOptions(props) {
  return usePopoverStoreOptions(props);
}
function useHovercardStoreProps(store, props) {
  return usePopoverStoreProps(store, props);
}
function useHovercardStore(props = {}) {
  const options = useHovercardStoreOptions(props);
  const store = useStore(
    () => Core.createHovercardStore(__spreadValues(__spreadValues({}, props), options))
  );
  return useHovercardStoreProps(store, props);
}

export {
  useHovercardStoreOptions,
  useHovercardStoreProps,
  useHovercardStore
};
